import imageInput from "@/mixins/image-input";
import StrategyPostModel from "@/views/strategy/models/strategy-post.model";

export default {
    name: "strategy-add",
    data() {
        return {
            item: {}
        }
    },
    computed: {
        isEditPage() {
            return this.$route.meta.edit;
        },
    },
    methods: {
        approve() {
            let data = new StrategyPostModel(this.item);
            let formData = new FormData();
            for (let key in data) {
                formData.append(key, data[key]);
            }
            if (this.isEditPage) {
                this.$store.dispatch("strategy/updateItem", {id: data.id, data: formData});
            } else {
                this.$store.dispatch("strategy/setItem", formData).then((res) => {
                    if (res) {
                        this.item = {};
                        this.resfresh = true;
                    }
                });
            }
        },
    },
    created() {
        let id = this.$route.params.id;
        if (this.isEditPage) {
            this.$store.dispatch("strategy/getItemById", id).then((res) => {
                if (res) {
                    this.item = res;
                }
            });
        }
    },
    mixins: [imageInput]
};
